import { createConsts, createActions } from '../../utils/redux';

import { DEFAULT_LOCALE } from '../../i18n';

export const consts = createConsts('ui', 'locale', ['SET_LOCALE']);
export const actions = createActions(consts);

export default (state = DEFAULT_LOCALE, action) => {
  switch (action.type) {
    case consts.SET_LOCALE:
      return action.payload;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/ui/locale.js